
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/komodo-wallet/desktop/import-private-key-or-seed-phrase",
      function () {
        return require("private-next-pages/docs/komodo-wallet/desktop/import-private-key-or-seed-phrase/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/komodo-wallet/desktop/import-private-key-or-seed-phrase"])
      });
    }
  